import React from 'react'
import { CreditApplication } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedCurrency, FormattedMessage } from '@divvy-web/i18n'

import ImageWrapper from '@sputnik/components/ImageWrapper'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'

interface OfferAcceptedStatusTileProps {
  creditApp: CreditApplication
}

const OfferAcceptedStatusTile = ({ creditApp }: OfferAcceptedStatusTileProps) => {
  const { statusUpdatedAt, fundableLimit } = creditApp || {}
  const [makeTestId] = useNameFormatter('OfferAcceptedStatusTile')
  const hasFundableLimit = fundableLimit && fundableLimit > 0

  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='hand holding a credit card'
            imageName='dashboard-application-accepted-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage='Thank you for accepting your offer{hasFundableLimit, select,
                true { of {fundableLimit}.}
                other {.}
              } We’ll verify your identity and business information. This may take 3-5 days. If we need more information, we’ll email you.'
            id='sputnik.OfferAcceptedStatusTile__+13/LL'
            values={{
              hasFundableLimit,
              fundableLimit: hasFundableLimit && <FormattedCurrency value={fundableLimit} />,
            }}
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Accepted on {date, date, long}'
            id='sputnik.OfferAcceptedStatusTile__Lu3X2f'
            values={{ date: new Date(statusUpdatedAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Offer accepted'
            id='sputnik.OfferAcceptedStatusTile__iy42WV'
          />
        }
      />
    </div>
  )
}

export default OfferAcceptedStatusTile
